import { Button, Flex } from "antd"
import { Modal } from "ui/Modal"
import { Text, Title } from "ui/Typography"
import WarningOutlinedWithBg from "ui/WarningOutlinedWithBg"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import { Icon } from "ui/Icon"

const BookingConfirmationModal = ({ open, handleCancel, clientName, tripDate, bookingConfirmStatus, handleConfirm }) => {
  const { t } = useTranslation()
  const isAccept = bookingConfirmStatus === "accept"
  return (
    <Modal
      centered
      width={430}
      title={
        <Flex justify="space-between" align="center">
          <div className="flex-1 text-center">{isAccept ? <Icon type="feather" name="CheckCircle" /> : <WarningOutlinedWithBg />}</div>
        </Flex>
      }
      open={open}
      onCancel={handleCancel}
    >
      <Flex vertical gap={24}>
        <Flex vertical gap={16}>
          <Title level={3}>{isAccept ? "Accept Booking" : "Decline Booking"}</Title>
          <Text>
            Are you sure you want to {isAccept ? "accept" : "decline"} booking for <strong>{clientName}</strong> on{" "}
            <strong>{tripDate}?</strong>
          </Text>
        </Flex>
        <Flex gap={12}>
          <Button variant="outlined" color="primary" onClick={handleCancel}>
            {t("global.cancel")}
          </Button>
          <Button type="primary" danger={!isAccept} onClick={handleConfirm}>
            {isAccept ? "Accept" : "Decline"}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}

BookingConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func.isRequired,
  clientName: PropTypes.string.isRequired,
  tripDate: PropTypes.string.isRequired,
  bookingConfirmStatus: PropTypes.string.isRequired,
  handleConfirm: PropTypes.func.isRequired
}

export default BookingConfirmationModal
